import React from 'react';
import i18n from '@i18n';
import { firstToUpperCase } from '@/common/client';
import { DialogActions, DialogBody, DialogButton, DialogTitle } from '@/ui/dialogs/Dialog';

function CashinNotAvailable({ cashinOfferStatus, closeDialog }) {
    const message = i18n(`ticketus.cashin.offer.${cashinOfferStatus}`);
    return (
        <div className="cashin-not-available">
            <DialogTitle>
                <h2 className="icon">{firstToUpperCase(i18n('commons.term.odkupH1'))}</h2>
            </DialogTitle>
            <DialogBody>
                <p>{message}</p>
            </DialogBody>
            <DialogActions>
                <DialogButton onClick={() => closeDialog(message)}>{i18n('cashin.term.close')}</DialogButton>
            </DialogActions>
        </div>
    );
}

export default CashinNotAvailable;
